/*************************************************/
/* Slider                                        */
/*************************************************/
// Import necessary libraries and modules
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

// Use the Swiper modules
Swiper.use([Navigation, Pagination]);

// Define the main function
export function timeline() {
    const timelineSliderSelector = '.timeline__slider.swiper';
    const timelinePaginationIndexSelector = '.timeline__pagination-index';

    const animationInterval = 15;
    const animationDuration = 1200;
    const timelineInstances = [];

    // Initialize the timeline
    const init = () => {
        // Get all elements matching the timeline slider selector
        const timelineSliderSelectorElements = document.querySelectorAll(timelineSliderSelector);
        // Initialize each timeline slider
        timelineSliderSelectorElements.forEach(initializeTimelineSlider);
    };

    // Initialize a single timeline slider
    const initializeTimelineSlider = (slider) => {
        // Get the element for displaying the year
        const yearDisplay = slider.querySelector(timelinePaginationIndexSelector);

        // Create a Swiper instance for the timeline slider
        timelineInstances.push(new Swiper(slider, {
            slidesPerView: 1,
            speed: animationDuration,
            direction: "horizontal",
            resizeObserver: true,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: "progressbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: (swiper) => {
                    updateYearDisplay(swiper, yearDisplay);
                    updateYearDisplayPosition(swiper, yearDisplay);
                },
                slideChangeTransitionStart: (swiper) => {
                    animateYearPosition(swiper, animationDuration, yearDisplay);
                },
                resize: (swiper) => {
                    animateYearPosition(swiper, animationDuration, yearDisplay);
                }

            },
        }));
    };

    // Update the year display based on the active slide
    const updateYearDisplay = (swiper, yearDisplay) => {

        const activeSlide = swiper.slides[swiper.activeIndex];
        yearDisplay.textContent = activeSlide.getAttribute('data-year');
    };

    // Update the year display position based on progress
    const updateYearDisplayPosition = (swiper, yearDisplay) => {

        const progressBarFill = swiper.el.querySelector('.swiper-pagination-progressbar-fill');
        const progress = swiper.progress;
        const progressBarOffsetLeft = progressBarFill.getBoundingClientRect().width;
        const adjustedYearPosition = progress === 1 ? progressBarOffsetLeft - 30 : progressBarOffsetLeft;
        yearDisplay.style.left = `${adjustedYearPosition}px`;
    };

    // Animate the year display position during transition
    const animateYearPosition = (swiper, duration, yearDisplay) => {
        let animationProgress = 0;
        const animate = () => {
            if (animationProgress <= 1) {
                animationProgress += animationInterval / duration;
                updateYearDisplayPosition(swiper, yearDisplay);
                requestAnimationFrame(animate);
                updateYearDisplay(swiper, yearDisplay);
            }
        };

        animate();
    };

    // Initialize the timeline when the page is loaded
    init();
}